let qlist = [
  {
    No: '1',
    name: 'tag',
    id: 'tag1',
    child: '0',
    parentid: '',
    childid: '',
    parent: '',
  },
  {
    No: '2',
    name: 'tag',
    id: 'tag2',
    child: '0',
    parentid: '',
    childid: '',
    parent: '',
  },
  {
    No: '3',
    name: 'tag',
    id: 'tag3',
    child: '0',
    parentid: '',
    childid: '',
    parent: '',
  },
  {
    No: '4',
    name: 'tag',
    id: 'tag4',
    child: '0',
    parentid: '',
    childid: '',
    parent: '',
  },
]

// -------------------------------------------------------------
// ～右側タグについて～
// 2022年7月8日の再校戻りにて、デザインの変更指示があり、「style.css」と「common.js」の改修が必要ですが、
// 「練習問題」の校了日が2022/7/15、「本問題」の校了日が2022/7/19)となっているため、それらの処理がこの「練習問題」には反映されていません。
// 「練習問題」の「style.css」「common.js」と「本問題」の「style.css」「common.js」は別物として扱う必要がありますのでご注意ください
// -------------------------------------------------------------
function pageCreate() {
  const tagList = document.getElementById('tagList')
  var zindex = qlist.length
  var wq = '"'
  qlist.forEach(function (keys) {
    if (keys.child == '0') {
      var tagListLi = document.createElement('li')
      tagListLi.className = 'fontsize15-26'
      tagList.appendChild(tagListLi)
      tagListLi.innerHTML =
        tagListLi.innerHTML +
        '<input type=' +
        wq +
        'radio' +
        wq +
        ' name=' +
        wq +
        'tag' +
        wq +
        ' id=' +
        wq +
        keys.id +
        wq +
        ' onclick=' +
        wq +
        'click1();' +
        wq +
        '>' +
        '<label class=' +
        wq +
        'tag tagnormal' +
        wq +
        ' for=' +
        wq +
        keys.id +
        wq +
        '>' +
        keys.No +
        '</label>'
    } else if (keys.child > 0) {
      var tagListLi = document.createElement('li')
      tagListLi.className = 'fontsize15-26'
      tagList.appendChild(tagListLi)

      var tagListDivP = document.createElement('div')
      tagListDivP.className = 'tag_parent'
      tagListDivP.id = keys.parentid
      tagListDivP.style.zIndex = zindex * 10
      tagListDivP.innerHTML =
        '<input type=' +
        wq +
        'radio' +
        wq +
        ' name=' +
        wq +
        'tag' +
        wq +
        ' id=' +
        wq +
        keys.id +
        wq +
        ' onclick=' +
        wq +
        'click1();' +
        wq +
        '>' +
        '<label class=' +
        wq +
        'tag tagnormal' +
        wq +
        ' for=' +
        wq +
        keys.id +
        wq +
        '>' +
        keys.No +
        '</label>'
      tagListLi.appendChild(tagListDivP)

      var tagListDivC = document.createElement('div')
      tagListDivC.className = 'tag_childes'
      tagListDivC.id = keys.childid
      tagListDivC.style.zIndex = zindex * 10 - 5
      tagListLi.appendChild(tagListDivC)
    }
    if (keys.parent != '') {
      var currentElement = document.getElementById(keys.childid)
      currentElement.innerHTML =
        currentElement.innerHTML +
        '<input type=' +
        wq +
        'radio' +
        wq +
        ' name=' +
        wq +
        'tag_child' +
        wq +
        ' id=' +
        wq +
        keys.id +
        wq +
        ' onclick=' +
        wq +
        'click1();' +
        wq +
        '>' +
        '<label class=' +
        wq +
        'tag tagnormal' +
        wq +
        ' for=' +
        wq +
        keys.id +
        wq +
        '>' +
        keys.No +
        '</label>'
    }
    zindex = zindex - 1
  })
}
function footerReset() {
  var winWidth = window.innerWidth
  var winHeight = window.innerHeight
  var mainAspect = 1205 / 2000
  var topAspect = 980 / 1205
  var footer = document.getElementById('footer')
  if (winWidth <= 2000 && winWidth >= 1100) {
    footer.style.top = winWidth * mainAspect * topAspect - 10 + 'px'
  } else if (winWidth > 2000) {
    footer.style.top = '980px'
  } else {
    footer.style.top = '545px'
  }
}
function selectTag(tagId) {
  // コンバイン変更 start
  // var q_numElem = document.getElementById('q_num')
  // while (q_numElem.firstChild) {
  //   q_numElem.removeChild(q_numElem.firstChild)
  // }
  // var targetQimg = document.createElement('img')
  // var selectedNo
  qlist.forEach(function (keys) {
    if (keys.id == tagId) {
      // selectedNo = keys.No
      if (Number(keys.child) == 0) {
        var tagNameEl = document.getElementById('currentTagName')
        tagNameEl.value = tagId
        tagNameEl.dispatchEvent(new Event('input'))
      }
    }
  })
  // targetQimg.src = selectedNo + '/img/' + selectedNo + '.svg'
  // q_numElem.appendChild(targetQimg)
  // コンバイン変更 end
  var selectedTag = document.getElementById(tagId)
  selectedTag.checked = true
  var selectElement = document.querySelector('label[for="' + tagId + '"]')
  selectElement.className = 'tag tagnotsolved'
}

function click1(e) {
  var e = e || window.event
  var elem = e.target || e.srcElement
  var elemId = elem.id
  var targetChildId
  var childlength
  qlist.forEach(function (keys) {
    if (keys.id === elemId) {
      elemNo = keys.No
      if (keys.childid != '') {
        targetChildId = keys.childid
      }
      childlength = keys.child
    }
  })
  let familyArr = []
  qlist.forEach(function (keys) {
    if (keys.child == '' && keys.childid == targetChildId) {
      familyArr.push(keys.id)
    }
  })
  if (targetChildId != '') {
    var targetElem = document.getElementById(targetChildId)
  }
  var visbleAllElem
  var tag_childAllElem
  if (childlength > 0) {
    if (targetElem.className == 'tag_childes') {
      visbleAllElem = document.querySelectorAll('.tag_childes_visible')
      for (var i = 0; i < visbleAllElem.length; i++) {
        visbleAllElem[i].className = 'tag_childes'
      }
      tag_childAllElem = document.getElementsByName('tag_child')
      if (tag_childAllElem.length > 0) {
        for (var j = 0; j < tag_childAllElem.length; j++) {
          tag_childAllElem[j].checked = false
        }
      }
      targetElem.className = 'tag_childes_visible'
    } else {
      targetElem.className = 'tag_childes'
    }
  } else if (familyArr.includes(elemId)) {
  } else {
    visbleAllElem = document.querySelectorAll('.tag_childes_visible')
    if (visbleAllElem.length > 0) {
      for (var i = 0; i < visbleAllElem.length; i++) {
        visbleAllElem[i].className = 'tag_childes'
      }
    }
    tag_childAllElem = document.getElementsByName('tag_child')
    if (tag_childAllElem.length > 0) {
      for (var j = 0; j < tag_childAllElem.length; j++) {
        tag_childAllElem[j].checked = false
      }
    }
  }

  var route = document.getElementById('route')
  var tdroute1 = document.getElementById('tdroute1')
  var tdroute2 = document.getElementById('tdroute2')
  if (elemNo == qlist[qlist.length - 1]['No']) {
    route.className = 'next finish'
    tdroute1.setAttribute('colspan', '4')
    tdroute2.setAttribute('colspan', '2')
    footerReset()
  } else {
    route.className = 'next route'
    tdroute1.setAttribute('colspan', '3')
    tdroute2.setAttribute('colspan', '2')
    footerReset()
  }
  var way = document.getElementById('way')
  if (elemNo == '1') {
    way.className = 'way nonvisible'
    footerReset()
  } else {
    way.className = 'way prev'
    footerReset()
  }
  console.log(elemNo)
  selectTag(elemId)
}

window.addEventListener(
  'resize',
  function () {
    footerReset()
  },
  false
)

export { pageCreate, footerReset, selectTag }
